
import Vue, { PropType } from 'vue';
import { FeatureTourMediaType } from '../types/featureTour';

export default Vue.extend({
	name: 'FeatureTourMedia',
	props: {
		mediaUrl: { type: String, default: null },
		mediaType: { type: String as PropType<FeatureTourMediaType>, default: 'video' },
		posterUrl: { type: String, default: null },
		placeholderLabel: { type: String, default: '' },
		mediaId: { type: String, default: '' },
		// The expand affordance is the inline-card's job — the theater
		// modal itself renders this same component (with allowExpand
		// false) so the maximize button doesn't appear at full screen.
		allowExpand: { type: Boolean, default: true },
	},
});
